export default __webpack_public_path__ + "static/media/bacqueville3.500af236.jpg";